import { buildQueryString } from "../utils/dateUtils"; // adjust path if needed

/**
 * Load schedule data from backend API.
 * Builds query string using params (location, room, line, etc.).
 */
const fetchWithToken = async (url, token, options = {}) => {
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };
  const res = await fetch(url, { ...options, headers });
  
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res;
};

export const loadScheduleData = async (params, token) => {
  const queryString = buildQueryString(params);
  const url = `${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/schedule-data/v1?${queryString}`;
  try {
    const response = await fetchWithToken(url, token);
    const data = await response.json();

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const rows = data.map((item, index) => ({
      id: item.work_order_id || index,
      work_order_id: item.work_order_id,
      Mon: item.Mon,
      Tue: item.Tue,
      Wed: item.Wed,
      Thu: item.Thu,
      Fri: item.Fri,
      Sat: item.Sat,
      Sun: item.Sun,

      Mon_a: item.Mon_a,
      Tue_a: item.Tue_a,
      Wed_a: item.Wed_a,
      Thu_a: item.Thu_a,
      Fri_a: item.Fri_a,
      Sat_a: item.Sat_a,
      Sun_a: item.Sun_a,

      // Hidden fields (for PDF only)
      Mon_c: item.Mon_c,
      Tue_c: item.Tue_c,
      Wed_c: item.Wed_c,
      Thu_c: item.Thu_c,
      Fri_c: item.Fri_c,
      Sat_c: item.Sat_c,
      Sun_c: item.Sun_c,

      Mon_h: item.Mon_h,
      Tue_h: item.Tue_h,
      Wed_h: item.Wed_h,
      Thu_h: item.Thu_h,
      Fri_h: item.Fri_h,
      Sat_h: item.Sat_h,
      Sun_h: item.Sun_h,

      Mon_ah: item.Mon_ah,
      Tue_ah: item.Tue_ah,
      Wed_ah: item.Wed_ah,
      Thu_ah: item.Thu_ah,
      Fri_ah: item.Fri_ah,
      Sat_ah: item.Sat_ah,
      Sun_ah: item.Sun_ah,

      total: parseFloat(item.total || 0),

      work_order_description: item.work_order_item_description || "",
      work_order_code: item.work_order_item_code || "",
      line_name: item.line_name,
      plant_location: item.plant_location,
      job_number: item.job_number?.toString(),
      bulk_item_code: item.bulk_items?.[0]?.bulk_item_code || "",
      bulk_item_work_order: item.bulk_items?.[0]?.bulk_item_work_order || "",
      bulk_item_description: item.bulk_items?.[0]?.bulk_item_desc || "",
      bulk_item_reference: item.bulk_items?.[0]?.bulk_item_reference || "",
      work_order_reference: item.work_order_reference || "",
      notes: item.notes || "",
      people: item.people || "",
      teardown_label: item.teardown_label || "",
      teardown_time: item.teardown_duration || "",
      starts_at: item.start_time || "",
      ends_at: item.end_time || "",
    }));

    return rows;
  } catch (error) {
    console.error("API Fetch Error:", error);
    throw error;
  }
};

/**
 * Fetch list of all available locations.
 */
export const loadLocations = async (token) => {
  const url = `${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/locations`;
  const response = await fetchWithToken(url, token);
  if (!response.ok) throw new Error("Failed to load locations");
  return await response.json();
};

/**
 * Fetch rooms for a given location.
 */
export const loadRooms = async (location, token) => {
  const url = `${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/getRooms?location=${location}`;
  const response = await fetchWithToken(url, token);
  if (!response.ok) throw new Error("Failed to load rooms");
  return await response.json();
};

/**
 * Fetch lines for a given location + room.
 */
export const loadLines = async (location, room, token) => {
  const url = `${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/getLines?location=${location}&roomId=${room}`;
  const response = await fetchWithToken(url, token);
  if (!response.ok) throw new Error("Failed to load lines");
  const data = await response.json();
  return data["lines"];
};
